import { Helmet } from 'react-helmet-async';

interface Props {
  title: string;
}

export function PageMetadata({ title }: Props) {
  return <Helmet title={title} />;
}
